import { ArticleHeader } from "components/pages/blog/article/ArticleHeader";
import { Page } from "components/layout/Layout";
import { useArticleSinglePageContext } from "@/helpers/contexts/ArticleSinglePageContext";

import { TArticleContent } from "@/components/pages/blog/article/TArticleContent";

export const TArticlePage = () => {
  const data = useArticleSinglePageContext();

  if (!data) return null;

  const { article, isPreview } = data;

  return (
    <Page {...article.meta} pageType="Article" headerColor="black" isPreview={isPreview}>
      <ArticleHeader showShareBtn={false} showCategoriesSearch={false} isTranslation />
      <TArticleContent showComments={false} showShareBtn={false} showLikes={false} />
    </Page>
  );
};
